import React, { useEffect, useRef, useState } from "react";
import { Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import ReactMarkdown from "react-markdown";
import MarkdownText from "./MarkdownText";

const AgendaItemsRevised = ({ agendaItems }) => {
  const { Title } = Typography;

  const [contentHeights, setContentHeights] = useState([]);
  const descriptionRefs = useRef([]);
  const containerRefs = useRef([]);
  const dataRef = useRef({});

  let carouselDragScreenX = -1; 

  useEffect(() => {
    // Calculate the height of each container for each item
    const heights = agendaItems.map((_, index) => {
      const containerHeight = containerRefs.current[index]?.offsetHeight || 0;
      return containerHeight;
    });
    setContentHeights(heights);
  }, [agendaItems]);

  const imageCarousel = (item) => {
    if (item.images && item.images.length > 0) {
      return (
        <div
          style={{
            overflow: "hidden",
            maxWidth: "90vw",
            flexShrink: 0,
            paddingTop: "0.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              overflowX: "auto",
              flexShrink: 0,
              maxWidth: "85rem",
              msOverflowStyle: "none",
              scrollbarWidth: "none",
              WebkitScrollbar: { display: "none" },
            }}
            onDrag={(event) => {
              if (event.pageX > 0) {
                event.currentTarget.scrollBy(carouselDragScreenX > 0 ? carouselDragScreenX - event.pageX : 0, 0);
                carouselDragScreenX = event.pageX;
              } else {
                carouselDragScreenX = -1;
              }
            }}
          >
            {item.images.map((image, imgIndex) => (
              <div
                key={`image-container-${imgIndex}`}
                style={{
                  width: "11rem",
                  height: "8rem",
                  display: "flex",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    width: "10rem",
                    height: "8rem",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "white",
                    borderRadius: 8,
                    flexShrink: 0,
                  }}
                >
                  <img
                    key={`image-${imgIndex}`}
                    src={image}
                    alt=""
                    style={{
                      height: "100%",
                      width: "auto",
                      borderRadius: 8,
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ width: "1rem", height: "1rem" }}></div>
              </div>
            ))}
            <div
              style={{ width: "1rem", minWidth: "1rem", height: "1rem" }}
            ></div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  useEffect(() => {
    console.log("data ref height", dataRef?.current?.offsetHeight);
  }, [dataRef?.current?.offsetHeight]);

  return (
    <div style={{ maxWidth: "100%", margin: 'auto' }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          margin: "0 auto",
        }}
      >
        {agendaItems.map((item, index) => {
          const myImageCarousel = imageCarousel(item);
          return (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                marginBottom: "0.8rem",
                overflow: "hidden",
                minHeight: "4rem",
                maxWidth: "100%",
              }}
              ref={(el) => (containerRefs.current[index] = el)}
            >
              <div style={{ display: "flex", maxWidth: "100%" }}>
                {/* Location icon and dots */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <EnvironmentOutlined />
                  {index !== agendaItems.length - 1 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontWeight: "bold",
                        marginTop: "0.5rem",
                        gap: "10px",
                        position: "absolute",
                        paddingTop: "1rem",
                      }}
                    >
                      {Array.from({ length: 50 }).map((_, dotIndex) => (
                        <div key={dotIndex} style={{ lineHeight: "0.5" }}>
                          .
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div
                  style={{ width: "1rem", minWidth: "1rem", height: "1rem" }}
                ></div>
                {/* Description, Title, and Carousel */}
                <div
                  ref={dataRef}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "100%",
                  }}
                >
                  <Title
                    level={5}
                    className="margin0 custom-title-margin"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {item.title}
                  </Title>
                  <div
                    style={{
                      fontSize: "1.2rem",
                      textAlign: "justify",
                      fontWeight: "500",
                      color: "grey",
                    }}
                  >
                    <MarkdownText
                      description={item.description || ""}
                      expandable={false}
                      lessMargin={true}
                    />
                  </div>
                  {myImageCarousel && (
                    <div style={{ display: "flex" }}>{myImageCarousel}</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgendaItemsRevised;
